import React, {useEffect, useState} from 'react';
import {Button, ButtonGroup, Card, CardBody, CardHeader, CardTitle, Col, Row} from "reactstrap";
import classNames from "classnames";
import {BarChartTransformer} from "../../../services/chart.transformer";
import BarChart from "../../../../components/Chart/BarChart";

const BarChartReport = (props) => {
    const {data} = props
    const [years, setYear] = useState([])
    const [datasets, setDatasets] = useState([])
    const [bigChartData, setBigChartData] = useState(null)
    const [chartData, setChartData] = useState(null)

    const dataset = async () => {
        let years = []
        let dataset = []
        await data?.map(d => {
            if (!years.includes(d.year)) {
                years.push(d.year)
            }
        })
        await
            years.map(y => {
                dataset[y] = []
                data?.map((d, i) => {
                    if (d.year === y) {
                        dataset[y].push(d)
                    }
                })
            })
        await setDatasets(dataset)
        await setBigChartData(years[0])
        await setYear(years)
        setChartData(dataset[years[0]])
    }

    useEffect(() => {
        dataset()
    }, [data])

    const setChart = (years) => {
        setBigChartData(years)
        setChartData(datasets[years])
    }

    return (
        <Col xs="12">
            <Card className="card-chart">
                <CardHeader>
                    <Row>
                        <Col className="text-right" sm="6">
                            <h5 className="card-category">{props.title}</h5>
                        </Col>
                        <Col sm="6">

                            <ButtonGroup
                                className="btn-group-toggle float-left"
                                data-toggle="buttons"
                            >
                                {
                                    years && years.map(data => (
                                        <Button
                                            tag="label"
                                            className={classNames("btn-simple", {
                                                active: bigChartData === data,
                                            })}
                                            color="info"
                                            id={data}
                                            size="sm"
                                            onClick={() => setChart(data)}
                                        >
                                            <span
                                                className="d-none d-sm-block d-md-block d-lg-block d-xl-block">{data}</span>
                                            <span className="d-block d-sm-none"><i
                                                className="tim-icons icon-single-02"/></span>
                                        </Button>
                                    ))
                                }

                            </ButtonGroup>
                        </Col>
                    </Row>
                </CardHeader>
                <CardBody>
                    <div className="chart-area">
                        {chartData && <BarChart
                            type={props.type}
                            data={BarChartTransformer(chartData,props.label)}
                            
                        />}
                    </div>
                </CardBody>
            </Card>
        </Col>
    )
};

export default BarChartReport;